export interface ComunicadoEnviado {
  id: string;
  titulo: string;
  conteudo: string;
  tipo: 'email' | 'notificacao' | 'sms' | 'push';
  publico: 'todos' | 'empresas' | 'participantes' | 'especifico';
  empresasIds?: string[];
  segmento?: string;
  enviadoPor: string;
  dataEnvio: string;
  totalDestinatarios: number;
  totalEnviados: number;
  totalErros: number;
  status: 'enviado' | 'enviando' | 'agendado' | 'cancelado';
  agendadoPara?: string;
}

export const comunicadosEnviados: ComunicadoEnviado[] = [
  {
    id: 'COM-001',
    titulo: 'Atualização de Taxas de Resgate',
    conteudo: 'Prezados participantes, informamos que a partir de 15/05/2026, as taxas de processamento PIX serão reduzidas de 2.5% para 2.0%. Aproveitem!',
    tipo: 'email',
    publico: 'todos',
    enviadoPor: 'admin@getpoints.com.br',
    dataEnvio: '2026-05-01T10:00:00Z',
    totalDestinatarios: 1872,
    totalEnviados: 1865,
    totalErros: 7,
    status: 'enviado',
  },
  {
    id: 'COM-002',
    titulo: 'Nova Campanha: Desafio de Vendas de Maio',
    conteudo: 'Lançamos a campanha "Desafio Maio Turbo" com pontuação dobrada em vendas acima de R$ 1.000. Participe e conquiste prêmios exclusivos!',
    tipo: 'notificacao',
    publico: 'participantes',
    enviadoPor: 'admin@getpoints.com.br',
    dataEnvio: '2026-05-05T08:30:00Z',
    totalDestinatarios: 1872,
    totalEnviados: 1872,
    totalErros: 0,
    status: 'enviado',
  },
  {
    id: 'COM-003',
    titulo: 'Manutenção Programada - 07/05',
    conteudo: 'A plataforma ficará indisponível das 02h às 04h de 07/05/2026 para manutenção de infraestrutura. Planeje suas operações.',
    tipo: 'email',
    publico: 'empresas',
    enviadoPor: 'admin@getpoints.com.br',
    dataEnvio: '2026-05-06T14:00:00Z',
    totalDestinatarios: 12,
    totalEnviados: 12,
    totalErros: 0,
    status: 'enviado',
  },
  {
    id: 'COM-004',
    titulo: 'Alerta de Segurança - Troca de Senha',
    conteudo: 'Recomendamos que todos os usuários atualizem suas senhas. Utilize senhas fortes com pelo menos 12 caracteres, letras, números e símbolos.',
    tipo: 'push',
    publico: 'todos',
    enviadoPor: 'suporte@getpoints.com.br',
    dataEnvio: '2026-05-07T09:15:00Z',
    totalDestinatarios: 1884,
    totalEnviados: 1880,
    totalErros: 4,
    status: 'enviado',
  },
  {
    id: 'COM-005',
    titulo: 'Feriado: Atendimento Limitado',
    conteudo: 'No feriado de 01/05 o atendimento será via chatbot das 08h às 18h. Chamados urgentes serão priorizados.',
    tipo: 'sms',
    publico: 'empresas',
    enviadoPor: 'suporte@getpoints.com.br',
    dataEnvio: '2026-04-30T16:00:00Z',
    totalDestinatarios: 12,
    totalEnviados: 11,
    totalErros: 1,
    status: 'enviado',
  },
];

export const segmentosEmpresa = ['Tecnologia', 'Consultoria', 'Saúde', 'Educação', 'Logística', 'Software', 'Consultoria de TI'];

export const tiposComunicado = [
  { id: 'email', label: 'E-mail', icon: 'ri-mail-line' },
  { id: 'notificacao', label: 'Notificação In-App', icon: 'ri-notification-3-line' },
  { id: 'sms', label: 'SMS', icon: 'ri-message-3-line' },
  { id: 'push', label: 'Push Mobile', icon: 'ri-smartphone-line' },
];

export const publicosComunicado = [
  { id: 'todos', label: 'Todos os Usuários' },
  { id: 'empresas', label: 'Apenas Empresas' },
  { id: 'participantes', label: 'Apenas Participantes' },
  { id: 'especifico', label: 'Empresas Específicas' },
];